// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"37cc43d3","165":"c3c5c2a1","214":"16ba7d21","367":"5404a2a8","455":"49871d4a","514":"15b5fd41","565":"fb61f836","647":"e31b17e6","722":"7f1766a3","920":"cd6e5360","977":"7a7b0c82"}[chunkId] + ".chunk.js";
};